export default __webpack_public_path__ + "static/media/Logo_BVTQ_1200.9f1faf24.png";